import React from "react"
import { Col } from "react-bootstrap"

interface EventSignatureProps {
    signature: string
}

/**
 * Component to display event signature
 */
function EventSignature({ signature }: EventSignatureProps) {
    if (!signature) {
        return null
    }

    return (
      <div className="tile operator-info" style={{ height: '100%' }}>
          <h6>Signature</h6>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', paddingBottom: '30px' }}>
            <img 
              src={`data:image/png;base64,${signature}`} 
              alt="Event signature" 
            />
          </div>
      </div>
    )
}

export default EventSignature
